import { useDispatch, useSelector } from "react-redux";
import {
  IonButton,
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonInput,
  IonIcon,
  IonAlert,
  IonText,
  useIonLoading,
  useIonToast,
  useIonRouter,
} from "@ionic/react";
import { warningOutline, trashOutline } from "ionicons/icons";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { deleteCurrentProfile } from "../redux/actions/currentProfileActions";
import UpdateUsername from "../components/UpdateUsername/UpdateUsername";
function Settings() {
  const dispatch = useDispatch();
  const router = useIonRouter();
  const [password, setPassword] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  // Get loading/error state from Redux
  const [presentLoading, dismissLoading] = useIonLoading();
  const [presentToast] = useIonToast();

  const handleDelete = async () => {
    await presentLoading({ message: "Wiping data..." });
    // Dispatch the Redux action
    const resultAction = await dispatch(deleteCurrentProfile(password));

    if (deleteCurrentProfile.fulfilled.match(resultAction)) {
      const { status, data } = resultAction.payload;
      console.log(status, data);
      if (status === 200) {
        await dismissLoading();
        presentToast({ message: "Goodbye!", duration: 2000, color: "success" });
        router.push("/login"); // Redirect user after deletion
      } else {
        await dismissLoading();
        presentToast({
          message: data.error || "Wrong password",
          color: "danger",
        });
      }
    } else {
      await dismissLoading();
      presentToast({ message: "Action failed", color: "danger" });
    }
  };
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonContent className="ion-padding">
          <UpdateUsername />
          <div style={{ maxWidth: "500px", margin: "20px auto" }}>
            <IonCard color="light" style={{ padding: "10px" }}>
              <IonCardHeader>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <IonIcon
                    icon={warningOutline}
                    color="warning"
                    style={{ fontSize: "24px" }}
                  />
                  <IonCardSubtitle color="dark">Danger Zone</IonCardSubtitle>
                </div>
                <h2 style={{ fontWeight: "bold", marginTop: "10px" }}>
                  Delete Account
                </h2>
              </IonCardHeader>

              <IonCardContent>
                <IonText color="medium">
                  <p>
                    Deleting your account is <strong>permanent</strong>. This
                    will remove your profile, posts, and followers from our
                    database.
                  </p>
                </IonText>

                <div className="ion-margin-top">
                  <IonItem
                    fill="outline"
                    mode="md"
                    className="ion-margin-bottom"
                  >
                    <IonInput
                      label="Confirm Password" // Modern way to set labels
                      labelPlacement="stacked" // Keeps the label above the input
                      type="password"
                      placeholder="Enter your password"
                      value={password}
                      onIonInput={(e) => setPassword(e.detail.value)}
                    />
                  </IonItem>

                  <IonButton
                    expand="block"
                    color="danger"
                    disabled={!password}
                    onClick={() => setShowAlert(true)}
                  >
                    <IonIcon slot="start" icon={trashOutline} />
                    Permanently Delete
                  </IonButton>
                </div>
              </IonCardContent>
            </IonCard>

            <div className="ion-text-center ion-padding">
              <IonText color="medium" style={{ fontSize: "12px" }}>
                <p>
                  Having trouble? Contact{" "}
                  <a
                    href="mailto:admin@loonlog.ca"
                    style={{ color: "inherit", textDecoration: "underline" }}
                  >
                    admin@loonlog.ca
                  </a>
                </p>
              </IonText>
            </div>
          </div>

          <IonAlert
            isOpen={showAlert}
            onDidDismiss={() => setShowAlert(false)}
            header="Delete Your LoonLog Account?"
            message="This action cannot be undone. All your data will be wiped."
            buttons={[
              { text: "Cancel", role: "cancel" },
              {
                text: "Yes, Delete Everything",
                role: "destructive",
                handler: handleDelete,
              },
            ]}
          />
        </IonContent>
      </IonPage>
    </>
  );
}

export default Settings;
